export const C_API_LOGIN_URL = process.env.REACT_APP_API_LOGIN_URL;
export const C_API_SOCIAL_URL = process.env.REACT_APP_API_SOCIAL_URL;
export const C_API_REGISTER = process.env.REACT_APP_API_REGISTER;
export const C_API_PPID = process.env.REACT_APP_API_PPID;
export const C_API_NOTICIAS = process.env.REACT_APP_API_NOTICIAS;
export const C_API_QUERY = process.env.REACT_APP_API_QUERY;

//export const C_API_SEARCH_URL = 'http://sap:105/';

export const adUnits = [
  {
    idAdUnit:'responsive_article_leaderboard_1',
    data:{
      path: `${process.env.REACT_APP_AD_UNIT_PATH}/responsive_article_leaderboard_1`,
      sizes: [[320, 50], [320, 100], [728, 90], [980, 250]],
      containerId: 'div-gpt-ad-1743790838003-0',
      styles:{
        minWidht:'320px',
        minHeight:'50px'
      }
    }    
  },
  {
    idAdUnit:'responsive_article_leaderboard_2',
    data:{
      path: `${process.env.REACT_APP_AD_UNIT_PATH}/responsive_article_leaderboard_2`,
      sizes: [[320, 50], [320, 100], [728, 90], [980, 250]],
      containerId: 'div-gpt-ad-1743790901846-0',      
      styles:{
        minWidht:'320px',
        minHeight:'50px'
      }
    }
  },
  {
    idAdUnit:'responsive_article_vertical_1',
    data:{
      path: `${process.env.REACT_APP_AD_UNIT_PATH}/responsive_article_vertical_1`,
      sizes: [[120, 600], [160, 600], [300, 250], [300, 400]],
      containerId: 'div-gpt-ad-1743790978103-0',
      styles:{
        minWidht:'120px',
        minHeight:'250px'
      }
    }
  },
  {
    idAdUnit:'responsive_article_sticky',
    data:{
      path: `${process.env.REACT_APP_AD_UNIT_PATH}/responsive_article_sticky`,
      sizes: [[320, 50]],
      containerId: 'div-gpt-ad-1743790933010-0',
      styles:{
        minWidht:'320px',
        minHeight:'50px'
      }
    }
  },
];


export const PERMISSIONS = {
    MAX: {
      pages:['inicios','detalle']
      ,canView: ['inicio','detalle']
    },
    ADMIN: {
      pages:['inicio']
      ,canView: ['Dashboard', 'Reports', 'Settings'],
    },
    USER: {
      pages:['inicio']
      ,canView: ['Dashboard', 'Reports'],
    },
    GUEST: {
      pages:['inicio']
      ,canView: ['Dashboard'],
    },
  };


  export const menu1 =[
    { id:1,
      text:'Acerca de',
      url: process.env.REACT_APP_TERMS_URL
    },
    { id:2,
      text:"FAQ's",
      url: process.env.REACT_APP_FAQ_URL
    },
    { id:3,
      text:'Politica privacidad',
      url: process.env.REACT_APP_PRIVACY_URL
    }
  ];
  